/* eslint-disable */
const roles = [
  'Candidate',
  'Campaign Manager',
  'Digital Director/Consultant',
  'Field Director',
  'Other Campaign Staff',
  'Campaign Volunteer'
]

export default roles
